import { axiosInstance } from "@/use/utilities/axios/app/axios-instance";

export async function remove(id) {
  const axios = axiosInstance().primoLab;
  let message = [];

  await axios
    .delete(`/receipts`, {
      data: {
        id: id,
      }
    })
    .then(async (response) => {
      message = response.data.data;
    })
    .catch(async (error) => {
      throw error.response.data.errors;
    });

  return { message };
}
